import React, { useState } from "react";
import { makePostRequest } from "../../services/httpHelper";
import ErrorHandler from "../../services/ErrorHandler";
import { isEmail,isEmpty,isMobile } from "../../utils/formValidator";
import { CircularProgress } from "@material-ui/core";
import VerifyPhoneNumber from "./VerifyMobileNumber";
import { useNavigate} from 'react-router-dom';


var validationErrors ={};

const PersonalDataDeletionForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    msisdn:"",
    email: "",
    reason: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [serError, setServerError] = useState(null);
  const [errors,setErrors] = useState({});

  const navigate = useNavigate()
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmitx = (e) => {
    e.preventDefault();

    // Simulate form submission
    console.log("Form submitted:", formData);

    // Set the form as submitted
    setSubmitted(true);
  };


  const handleSubmit =async(e)=>{
     e.preventDefault();
     setServerError(null)
     setIsSubmitting(true)
     setErrors({})
     if(isEmpty(formData.fullName)){
       validationErrors.fullName ='Enter your full name'
     }
         
      if(!formData.msisdn){
       validationErrors.contactName ='Enter your account mobile number'
       
     }
     if(!isMobile(formData.msisdn)){
      validationErrors.phone='Invalid mobile number'
    
    }
      if(!isEmpty(formData.email)){
        if(!isEmail(formData.email)){
          validationErrors.email='Invalid Email Address'
      }

       
     }
 
      
  
      setErrors(validationErrors)
      //prevent data processing until all verification errors are fixed
   
      if(Object.keys(errors).length !==0){
       setIsSubmitting(false)
         return;
      }
        
   const data ={
     fullName:formData.fullName,
     email:formData.email,
     reason:formData.reason,
     msisdn:formData.msisdn,
   }
         const res = await makePostRequest('request-deletion-of-personal-data',data);
         if (res && res.errorType) {
             setIsSubmitting(false);
             const errorMessage = ErrorHandler(res)
             setServerError(errorMessage)
   
         } else {
            
           
             setIsSubmitting(false);
             setServerError(null);
             setSubmitted(true)
   
         }
     
   }

   const onClose=()=>{
    navigate('/')
   }

  return (
    <div className="container">
      {!submitted ? (
        <form onSubmit={handleSubmit} style={{ fontFamily: "Arial, sans-serif" }}>
          {isSubmitting && <CircularProgress/>}
          <h2>Request Personal Data Deletion</h2>
          {serError != null && <p style={{color:"red"}}>{serError}</p>}

          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="fullName" style={{ display: "block", marginBottom: "5px" }}>
              Full Name
            </label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                color:"black"
              }}
            />
          </div>
        
          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="email" style={{ display: "block", marginBottom: "5px" }}>
              Account Mobile Number
            </label>
            <input
              type="phone"
              id="msisdn"
              name="msisdn"
              value={formData.msisdn}
              onChange={handleChange}
              required
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                color:"black"
              }}
            />
          </div>
          

          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="email" style={{ display: "block", marginBottom: "5px" }}>
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                color:"black"
              }}
            />
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label htmlFor="reason" style={{ display: "block", marginBottom: "5px" }}>
              Reason for Deletion (Optional)
            </label>
            <textarea
              id="reason"
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                minHeight: "80px",
              }}
            />
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: "10px 20px",
                backgroundColor: "#007BFF",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{
                padding: "10px 20px",
                backgroundColor: "#f44336",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Submit Request
            </button>
          </div>
        </form>
      ) : (
        <div style={{ textAlign: "center", fontFamily: "Arial, sans-serif" }}>
          <VerifyPhoneNumber msisdn={formData.msisdn}/>
         
        </div>
      )}
    </div>
  );
};

export default PersonalDataDeletionForm;
